import { DateTime } from "luxon";

import json from "../../json/getInAppNotificationsList.json";

export default async () => {
  const awaitedJson = await json;
  const parsedJson = JSON.parse(
    JSON.stringify(awaitedJson),
  ) as typeof awaitedJson;

  parsedJson.items.map((item) => ({
    ...item,
    notifications: item.inAppNotifications.map((notification) => ({
      ...notification,
      timestamp: (notification.timestamp = DateTime.now()
        .minus({
          days: 2,
        })
        .toMillis()),
    })),
  }));

  return parsedJson;
};
